import {
	AddNewWorkspaceConnectionsViewProps,
	WorkspaceConnectedItemTypeConfiguration,
} from "src/components/views/workspaces/workspaceConnections/connectionTypes/WorkspaceConnectedItemTypeConfiguration.ts";
import i18n from "i18next";
import { faPen } from "@fortawesome/pro-regular-svg-icons";
import { ConnectProductChangeRequestsToWorkspaceDataGrid } from "src/components/views/workspaces/workspaceConnections/connectionTypes/productChangeRequest/ConnectProductChangeRequestsToWorkspaceDataGrid.tsx";
import { ProductChangeRequestDialog } from "src/components/views/erp/productChanges/requests/ProductChangeRequestDialog.tsx";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export const workspaceProductChangeRequestConnectionsConfiguration: WorkspaceConnectedItemTypeConfiguration = {
	typeLabel: i18n.t("product_change_request"),
	icon: faPen,
	isEnabled: () => true,
	addNewConnectionsView: (props: AddNewWorkspaceConnectionsViewProps) => (
		<ConnectProductChangeRequestsToWorkspaceDataGrid {...props} />
	),
	openItemDialog: ({ itemId, openDialog }) => {
		openDialog(({ closeDialog, onContentEdited }) => ({
			title: i18n.t("product_change_request"),
			size: "lg",
			agentContext: {
				key: defineAgentUiContextKey("workspaces.productChangeRequest.dialog"),
				title: i18n.t("product_change_request"),
				data: {
					productChangeRequestId: itemId,
				},
			},
			content: (
				<ProductChangeRequestDialog
					productChangeRequestId={itemId}
					mode={"manage"}
					onCompleted={async () => {
						await closeDialog();
					}}
					onFormEdited={onContentEdited}
				/>
			),
		}));
	},
};
